// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oGei","col":"styles_col__3YhgC"};